import _map from "lodash/map";
import { Button } from "../../Button/Button/Button";
import { Icon } from "../../Icon/Icon/Icon";
import styles from "./SocialBlockFooter.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var SocialBlockFooter = function SocialBlockFooter(_ref) {
  var config = _ref.config;
  var renderIcons = function renderIcons() {
    return _map(config, function (social, i) {
      var _social$attributes = social.attributes,
        attributes = _social$attributes === void 0 ? {} : _social$attributes;
      attributes.accessibilityLabel = social.label;
      return /*#__PURE__*/_jsx(Button, {
        className: styles.socialBlockFooterIconWrapper,
        accessibilityLabel: social.label,
        url: social.link,
        newWindow: true,
        type: "no-style",
        "data-e2e-name": "footer_social_button_".concat(i),
        attributes: social === null || social === void 0 ? void 0 : social.attributes,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.socialBlockFooterIcon,
          "data-e2e-name": "social_block_footer_icon",
          children: /*#__PURE__*/_jsx(Icon, {
            height: "32px",
            type: "social-".concat(i, "-round"),
            width: "32px"
          })
        })
      }, i);
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.socialBlockFooter,
    "data-e2e-name": "social_block_footer",
    children: renderIcons()
  });
};